module.exports = __webpack_public_path__ + "img/hourglass_dark.c9043024.svg";